import { FETCH_DYNAMIC_PAGES } from "../actions/dynamicPagesActions";

const initState = {};

const dynamicPagesReducer = (state = initState, action) => {
    if (action.type === FETCH_DYNAMIC_PAGES) {
        // Replace, not merge: the paths belong to ONE site base, and a stale entry from the
        // previously visited shop would link into the wrong tree.
        return {
            ...action.payload,
        };
    }

    return state;
};

export default dynamicPagesReducer;
